import { createTheme } from "@mui/material/styles";

const CustomTheme = createTheme({});

export { CustomTheme };
